// extracted by mini-css-extract-plugin
export default {"noRespondentGroups":"Administrator_noRespondentGroups__pepas","bold":"Administrator_bold__fjTyS"};